export const LISTING_STATUSES = ['personal', 'for-trade', 'for-sale'];
export const OFFER_STATUSES = ['pending', 'accepted', 'declined', 'withdrawn'];
export const OFFER_ITEM_SIDES = ['offered', 'requested'];
export const NOTIFICATION_TYPES = [
    'offer_received',
    'offer_accepted',
    'offer_declined',
    'offer_withdrawn',
    'wanted_match',
    'profile_viewed',
    'item_favorited',
    'catalog_milestone',
    'feedback_received',
    'feedback_reply',
];
export const FEEDBACK_TYPES = ['bug', 'feature', 'feedback', 'question'];
export const FEEDBACK_STATUSES = ['open', 'in_progress', 'resolved', 'closed'];
//# sourceMappingURL=community.js.map